import { Component } from '@angular/core';
import { ProductMenuFooterComponent } from '../../product-menu-footer.component';

@Component({
  selector: 'app-soul-bud-print-footer',
  templateUrl: './soul-bud-print-footer.component.html',
  styleUrls: ['./soul-bud-print-footer.component.scss'],
  standalone: false
})
export class SoulBudPrintFooterComponent extends ProductMenuFooterComponent {}
